"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModularHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ModularHeader = props => {
  const {
    leftWidgets,
    middleWidgets,
    rightWidgets,
    bottomWidgets,
    showBackDrop,
    onBackDropClick,
    leftWidgetClass,
    middleWidgetClass,
    rightWidgetClass,
    toolbarClasses,
    toolbarGap
  } = props;
  const classes = (0, _styles.default)();
  const toolbarCustomClasses = toolbarClasses ? toolbarClasses() : null;
  const toolbarDefaultStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    gap: toolbarGap
  };
  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    className: classes.header
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    style: toolbarDefaultStyles,
    classes: toolbarCustomClasses
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    className: leftWidgetClass || ''
  }, leftWidgets.map((Widget, k) => ({
    ...Widget,
    key: k
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    className: middleWidgetClass || ''
  }, middleWidgets.map((Widget, k) => ({
    ...Widget,
    key: k
  }))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    className: rightWidgetClass || ''
  }, rightWidgets.map((Widget, k) => ({
    ...Widget,
    key: k
  })))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0
    }
  }, bottomWidgets.map((Widget, k) => ({
    ...Widget,
    key: k
  }))), /*#__PURE__*/_react.default.createElement(_Backdrop.default, {
    className: classes.backdrop,
    open: showBackDrop,
    onClick: onBackDropClick
  }));
};
exports.ModularHeader = ModularHeader;
ModularHeader.propTypes = {
  /** Componente posicionados a esquerda */
  leftWidgets: _propTypes.default.arrayOf(_propTypes.default.node),
  /** Componente posicionados ao centro */
  middleWidgets: _propTypes.default.arrayOf(_propTypes.default.node),
  /** Componente posicionados a direita */
  rightWidgets: _propTypes.default.arrayOf(_propTypes.default.node),
  /** Componente posicionados abaixo */
  bottomWidgets: _propTypes.default.arrayOf(_propTypes.default.node),
  /** Se TRUE mostra o componente BackDrop */
  showBackDrop: _propTypes.default.bool,
  /** Função executada ao clicar no BackDrop */
  onBackDropClick: _propTypes.default.func,
  /** Classe para customização do Left Widget */
  leftWidgetClass: _propTypes.default.string,
  /** Classe para customização do Middle Widget */
  middleWidgetClass: _propTypes.default.string,
  /** Classe para customização do Right Widget */
  rightWidgetClass: _propTypes.default.string,
  /** Classes para customização da barra de ferramentas do Header */
  toolbarClasses: _propTypes.default.func,
  /** Define o espaçamento da barra de ferramentas do Header */
  toolbarGap: _propTypes.default.string
};
ModularHeader.defaultProps = {
  leftWidgets: [],
  middleWidgets: [],
  rightWidgets: [],
  bottomWidgets: [],
  showBackDrop: false,
  onBackDropClick: () => null,
  leftWidgetClass: null,
  middleWidgetClass: null,
  rightWidgetClass: null,
  toolbarClasses: null,
  toolbarGap: '1em'
};